<template lang="pug">
v-form
  v-row
    v-col( md="2" sm="6" cols="12" )
      DatePicker( v-model="dateStart" label="Дата начала" )
    v-col( md="2" sm="6" cols="12" )
      DatePicker( v-model="dateEnd" label="Дата окончания" )
    v-col( md="2" cols="12" )
      v-select( v-model="project" item-text="name" item-value="id" :items="projects" label="Проект" )
    //- v-col( md="2" cols="12" )
    //-   v-autocomplete(v-model="network" item-text="name" item-value="id" :items="networks" label="Ритейлер" multiple chips)
    v-col( md="2" cols="12" )
      v-autocomplete( v-model="city" label="Город" multiple chips :items="cities" )
    v-col( md="2" cols="12" )
      v-autocomplete(v-model="address" :items="addresses" label="Адрес" multiple chips)
    v-col.table-button( md="2" cols="12" )
      v-btn( rounded small class="mr-3" :disabled="!project" @click="getExport")
        v-icon mdi-content-save
  v-row
    v-col
      v-btn( :disabled="!valid" @click="loadMessages") Найти
  v-row
    v-col
      v-data-table( class="elevation-1 custom-table" :headers="headers" :items="messages" :loading="loading" loading-text="Загружается... Пожалуйста подождите" multi-sort )
        template(v-slot:body="{ items }")
          tbody
            tr(v-for="item in items" :key="item.id")
              td( style="width : 100px" ) {{ item.pointExtID }}
              td( style="width : 100px" ) {{ dateFormat(item.commentCreateDate) }}
              td( style="width : 600px" :class="!item.messageRead ? 'red-row' : ''" ) {{ item.messageBody }}
              td( style="width : 200px" ) {{ item.pointAddress }}
              td( style="width : 50px" )
                router-link(:to="'/report/' + item.reportUuid" target='_blank') Отчёт
              td( style="width : 100px" ) {{ dateFormat(item.reportSendDate) }}
  v-dialog(v-model="showLoadingDialog" width="unset" :persistent="loading")
      v-card
        v-card-title {{ loading ? 'Загрузка...' : 'Выберите формат экспорта' }}
        v-card-text(v-if="loading")
          v-progress-linear(color="deep-purple accent-4" indeterminate rounded height="6")

</template>


<script>
import { projectService, tradepointService, dialogMessageService, networkService } from '@/_services'
import { mapMutations, mapState, mapGetters } from "vuex";
import Export from './Export'
import DatePicker from './DatePicker';

export default {
  components: {
    Export,
    DatePicker
  },

  data: () => ({
    dateStart: new Date().toISOString().substr(0, 10),
    dateEnd: new Date().toISOString().substr(0, 10),
    project: 0,
    network: [],
    city: [],
    address: [],
    addresses: [],
    headers: [
      { text: 'Id', value: 'pointExtID' },
      { text: 'Дата', value: 'commentCreateDate' },
      { text: 'Комментарий', value: 'messageRead' },
      { text: 'Адрес', value: 'pointAddress' },
      { text: 'Отчет', value: 'reportUuid', sortable: false },
      { text: 'Дата отчета', value: 'reportSendDate', sortable: false }
    ],
    messages: [],
    loading: false,
    cities: [],
    user: 0,
    showLoadingDialog: false,
  }),

  mounted() {
    this.loadProjects()
  },

  
  watch: {
    project: function(val) {
      this.loadNetworks(val)
      this.loadCities()
    },
    network: function(val) {
      this.loadCities()
      this.loadAddresses()
    },
  },

  computed: {
    ...mapState("project", ["projects"]),
    ...mapState("network", { allnetworks: "networks" }),
    ...mapGetters("authentication", ["checkRole"]),
    ...mapGetters("user", ["users"]),

    isCustomer() {
      return this.checkRole(0)
    },

    valid() {
      return this.project != 0
    },

    networks() {
      return this.allnetworks[this.project]
    },
  },

  methods: {
    ...mapMutations("project", ["setProjects"]),
    ...mapMutations("network", ["setNetworkByProject"]),
    loadNetworks(id) {
      if (this.networks && this.networks.length > 0) return
      networkService.loadMyNetwork(id).then(data => {
        this.setNetworkByProject({ id: id, networks: data })
      })
    },

    getExport() {
      this.loading = true
      this.showLoadingDialog= true
      let closer = () => {
        this.showLoadingDialog = false
        this.loading = false
        this.dialog = false
      }
      let createLink = (filename, url) => {
        let tempEl = document.createElement("a");
        document.body.appendChild(tempEl);
        tempEl.style = "display: none";
        tempEl.href = url;
        tempEl.download = filename;
        tempEl.click();
        tempEl.remove();
      };
    
      let params = { start: this.dateStart, end: this.dateEnd };
      if (this.network.length > 0)
        params['networks'] = this.network.join()
      if (this.city.length > 0)
        params['cities'] = this.city.join()
      if (this.address.length > 0)
        params['addresses'] = this.address.map(encodeURIComponent).join(',')
      if (this.user > 0)
        params['user'] = this.user
      dialogMessageService.excel(this.project, params).then(function(response) {
        console.log(123);
        
        if ((typeof response.data) == 'string') {
          let content_disposition = response.headers['content-disposition'];
          let idx = content_disposition.indexOf('filename*=UTF-8\'\'');
          let filename = idx != -1 ? decodeURIComponent(content_disposition.substring(idx + 17)) : 'export';
          createLink(filename, response.data)
        } else {
          let content_disposition = response.headers['content-disposition'];
          let idx = content_disposition.indexOf('filename*=UTF-8\'\'');
          let filename = idx != -1 ? decodeURIComponent(content_disposition.substring(idx + 17)) : 'export';
          let blob = response.data;
          let objectURL = URL.createObjectURL(blob);
          createLink(filename, objectURL)
        }
        closer()
      }).catch((e) => {
        console.log(e)
        closer()
      })
    },

    loadProjects() {
      if (this.projects.length > 0) return
      projectService.list().then(data => {
        this.setProjects(data)
        if (data.length > 0)
          this.project = data[0].id
      })
    },

    loadMessages() {
      if (this.project === 0) return;
      this.loading = true
      let params = { start: this.dateStart, end: this.dateEnd };
      if (this.network.length > 0)
        params['networks'] = this.network.join()
      if (this.city.length > 0)
        params['cities'] = this.city.join()
      if (this.address.length > 0)
        params['addresses'] = this.address.map(encodeURIComponent).join(',')
      if (this.user > 0)
        params['user'] = this.user
      dialogMessageService.list(this.project, params).then((result) => {
        this.messages = result
        this.loading = false
      })
    },

    dateFormat(date) {
      const d = new Date(date)
      return `${String(d.getDate()).padStart(2, '0')}.${String(
        d.getMonth() + 1
      ).padStart(2, '0')}.${d.getFullYear()}`
    },

    loadCities() {
      tradepointService.loadCities(this.project, this.network.join()).then(data => this.cities = data)
    },

    loadAddresses() {
      tradepointService.loadAddresses(this.project, this.network.join()).then(data => this.addresses = data)
    },
  }
}
</script>
<style>
.custom-table table {
  border-collapse: collapse;
}

.custom-table th,
.custom-table td {
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}

.custom-table th:last-child,
.custom-table td:last-child {
  border-right: none;
}
</style>
<style scoped>
.red-row {
  background: #FF000033;
}
.table-button {
  display: flex;
  align-items: center;
}
</style>
